module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAMAAACecocUAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABpUExURUdwTGOa/zGA/zKD/6PH/4a1/6DF/4Gu/6PG/7fS/2Sg/1aW/3Oo/7XR/0eN/4Cx/7jT/1WV/0aL/zqH/2Of/6bG/yp7/yx9/yx9/0eN/4Cw/465/2Oe/1WV/53C/3Kn/ziE/6vL/yp7/2eIlOAAAAAZdFJOUwAU3Smvj0gJ3Znro7tk19e7YyxTnyjro4tGKyMlAAAATElEQVQI1z3NRQKAMBBD0dRb3N3vf0haYHirv0oAiL67+MDg1ceDC6AaP5lBvJIS0UIa7L8E+UQU1Ew0mN1e0u+39gykCWcmdYXTPm6PPQmWHfnv+wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCode/blue-dian.png
// module id = 8jCe
// module chunks = 0